import { Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import { Link } from "react-router-dom";
import * as roleService from "@/tra/tancis/ptli/ptl/role/services/PtliRoleService";
import { SF_ROLE_SRCH, URLS } from "@/tra/tancis/ptli/ptl/roleauth/services/PtliRoleAuthService";
import { comnUtils } from "@/comn/utils";

/**
 *  Role and Auth Link List
 *  !== 역할 및 권한 연결 목록 ==!
 */
export const PTLI1016001Q = () => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0002"],
    });
    const toast = useToast();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "COM0024" },
            { area: "comnCd", comnCd: "COM0052" },
        ],
    });

    const form = {
        roleSrch: useForm({
            defaultSchema: SF_ROLE_SRCH,
            defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    const grid = {
        roleAuthList: useGrid({
            defaultSchema: roleService.SG_ROLE_MGMT_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getRoleList: useFetch({
            api: (page = grid.roleAuthList.page, size = grid.roleAuthList.size) =>
                roleService.APIS.getRoleList(form.roleSrch.getValues(), page, size),
            enabled: comnUtils.isEmpty(form.roleSrch.errors),
            key: [grid.roleAuthList.page, grid.roleAuthList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.roleSrch.getValues(),
                    page: grid.roleAuthList.page,
                    size: grid.roleAuthList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const handler = {
        onSrchBtnClick: form.roleSrch.handleSubmit(
            () => {
                grid.roleAuthList.setPage(0);
                fetch.getRoleList.fetch(0);
            },
            () => toast.showToast({ type: "warning", content: "msg.00002" }), // Data is invalid, !== 데이터가 유효하지않습니다. ==!
        ),
        onGridCellClick: (cell: any) => {
            const { binding, rowValues } = cell;
            if (binding !== "roleId") return;

            setStore(pgeUid, {
                ...pgeStore,
                param: { ptlTpCd: rowValues.ptlTpCd, roleId: rowValues.roleId },
            });
        },
    };

    const render = {
        roleAuthList: {
            cell: {
                roleId: (props: any) => {
                    const { value } = props;
                    return <Link to={`${URLS.ptli1016002s}/${value}`}>{value}</Link>;
                },
            },
        },
    };

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.roleSrch.schema.roleId} />
                            <Group.Control {...form.roleSrch.schema.roleNm} />
                        </Group.Row>
                    </Group.Section>

                    <Layout>
                        <Layout.Right>
                            <Layout.Button role={"search"} onClick={handler.onSrchBtnClick} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Grid
                        {...grid.roleAuthList.grid}
                        data={fetch.getRoleList.data?.roleList}
                        render={render.roleAuthList}
                        onCellClick={handler.onGridCellClick}
                    />
                </Group.Body>
            </Group>
        </Page>
    );
};
